import immerize from '../immerize'

const defaultState = {
  isAuth: false,
  isPublic: false,
  info: {
    created: null,
    id: null,
    principalType: null,
    role: null,
    ttl: null,
    userId: null,
    profile: {
      email: null,
    },
  },
  status: 'logoutFulfilled',
  error: null,
  message: '',
  code: null,
  showAlert: false,
}

function reducer(
  state = {
    ...defaultState,
    ...(localStorage.getItem('guardexpert_logon')
      ? JSON.parse(localStorage.getItem('guardexpert_logon'))
      : {}),
  },
  action
) {
  switch (action.type) {
    case 'USER_LOGIN_PENDING':
      state.status = 'loginPending'
      break
    case 'USER_LOGIN_FULFILLED': {
      state.info = { ...action.payload }
      state.status = 'loginFulfilled'
      state.error = null
      state.code = null
      state.isAuth = true
      state.showAlert = false
      localStorage.setItem('guardexpert_logon', JSON.stringify(state))
      break
    }
    case 'USER_LOGIN_REJECTED':
      localStorage.removeItem('guardexpert_logon')
      state.status = 'loginRejected'
      state.error = action.payload.error
      state.message = action.payload.message
      state.code = action.payload.code
      state.showAlert = true
      break
    case 'USER_LOGOUT_PENDING':
      state.status = 'logoutPending'
      break
    case 'USER_LOGOUT_FULFILLED':
      localStorage.removeItem('guardexpert_logon')
      state.info = {
        created: null,
        id: null,
        principalType: null,
        role: null,
        ttl: null,
        userId: null,
        profile: {
          email: null,
        },
      }
      state.status = 'logoutFulfilled'
      state.error = null
      state.code = null
      state.isAuth = false
      state.isPublic = false
      state.showAlert = false
      break
    case 'USER_LOGOUT_REJECTED':
      localStorage.removeItem('guardexpert_logon')
      state.info = {
        created: null,
        id: null,
        principalType: null,
        role: null,
        ttl: null,
        userId: null,
        profile: {
          email: null,
        },
      }
      state.status = 'logoutFulfilled'
      state.error = null
      state.code = null
      state.isAuth = false
      state.showAlert = false
      break
    case 'USER_LOGON_RESTORE':
      state = action.payload
      break
    case 'USER_LOGON_DISMISS':
      state.showAlert = false
      break
    default:
      return state
  }
  return state
}

export default immerize(reducer)
